// extracted by mini-css-extract-plugin
export default {"lazyload_common":"LazyLoadCommon_lazyload_common__F-wBl"};
    if(module.hot) {
      // 1787713409144
      var cssReload = require("/home/ubuntu/qai.sysnthesis/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  